function handleUnauthorized(unauthorizedCallback: () => void) {
  return (error: Error) => {
    const { message } = error;
    if (message === 'Unauthorized' || message === 'Forbidden') {
      unauthorizedCallback();
    } else throw error;
  };
}

export default handleUnauthorized;
